import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    marketplaceAsset: null,
    marketplaceAssets: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const marketplaceAssetsReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.MARKETPLACEASSET_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.MARKETPLACEASSET_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.MARKETPLACEASSET_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default marketplaceAssetsReducer;
